export default __webpack_public_path__ + "static/media/crownbuilding.eccacb47.png";